import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { money } from "@/lib/currency";
import { orderNo } from "@/lib/order";

export const DeleteOrderDialog = ({ order, currency, onClose, onDone }) => {
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await api.delete(`/my/orders/${order.id}`);
      toast.success(`Order #${orderNo(order)} deleted`);
      onDone();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] bg-black/70 flex items-center justify-center p-4" onClick={onClose}>
      <div data-testid="delete-order-dialog" className="bg-slate-900 border border-slate-800 rounded-2xl w-full max-w-sm p-6 space-y-4 fade-up" onClick={(e) => e.stopPropagation()}>
        <h3 className="font-heading text-xl font-bold">Delete order #{orderNo(order)}?</h3>
        <p className="text-sm text-slate-400">Table {order.table_number} · {money(order.total, currency)}. This permanently removes the order and cannot be undone. To let the diner know why, use Cancel instead.</p>
        <div className="grid grid-cols-2 gap-2">
          <button data-testid="delete-order-keep" onClick={onClose} className="rounded-xl py-3 font-semibold bg-slate-800 hover:bg-slate-700 transition-colors">Keep order</button>
          <button data-testid="delete-order-confirm" onClick={confirm} disabled={busy} className="inline-flex items-center justify-center gap-2 rounded-xl py-3 font-semibold bg-red-600 hover:bg-red-700 disabled:opacity-60 transition-colors">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4" />} Delete
          </button>
        </div>
      </div>
    </div>
  );
};
